<template>
  <ProductSeriesPage
    :title="title"
    :subtitle="subtitle"
    :hero-image="heroImage"
    :items="items"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductSeriesPage from '@/components/ProductSeriesPage.vue'
import seriesProductImages from './seriesProductImages'

const { t, tm, locale } = useI18n()
const heroImage = require('@/assets/images/pixso-automotive-products/hero-pbox.png')
const isEnglish = computed(() => locale.value === 'en')

const itemImages = [
  seriesProductImages.p21s
]

const title = computed(() => t('AutomotiveIndex.series.items.pbox.title'))
const subtitle = computed(() => (isEnglish.value ? '' : t('AutomotiveIndex.series.items.pbox.subtitle')))

const items = computed(() => {
  const seriesItems = tm('P21S.series.items') || []

  return seriesItems.map((item, index) => ({
    title: item.title,
    description: item.description,
    image: itemImages[index],
    featured: item.featured,
    to: '/product/automotive/pbox/p21s'
  }))
})
</script>
